import React from "react";
import logo from '../../assets/images/logo.svg';
import "./Topbar.css";

export default function Topbar() {
    return (
        <header className="mainHeader">
            <div className="d-flex align-items-center justify-content-between">
                <div className="d_flex align-items-center">
                    <h1>i18n Editor</h1>
                </div>
                <img src={logo} alt="Logo thefaculty" className="logo" />
            </div>
        </header>
    )
}